import { Dialog } from '@angular/cdk/dialog';
import { formatDate } from '@angular/common';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { CustomActionParametersComponent } from 'src/app/forms/simple-datagrid/custom-action-parameters/custom-action-parameters.component';
import { parameter } from 'src/app/interfaces/action';
import { DialogService } from 'src/app/services/dialog.service';
import { FileLoaderServices } from 'src/app/services/FileLoader.services';
import { GlobalErrorHandler } from 'src/app/services/GloabalErrorHandler.services';
import { LanguageServices } from 'src/app/services/LanguageServices';
import { SnackbarService, SnackMessage } from 'src/app/services/snackbar.service';
import { ButtonList } from 'src/app/system-utils/actions-buttons/actions-buttons.component';


export class FileOptions{
    pk: string[];
    condicao: string;
    blobField: string;
    entityName:string;
    data:FieldConfiguration[] = [];
    secondsToExpire:number;
    fileTypeUpload:string[];
    multipleFiles?:boolean;
    showCloseButton?:boolean = true;
    parameters?:parameter[]
    saveBlob?: boolean = true;
}


export interface FieldConfiguration{
  name:string;
  type:string;
  value:string;
}


export interface FileData{
  error:string;
  index:number; 
  filename:string; 
  filetype:string; 
  file:File; 
  progress:number;
  size:number
}

@Component({
    selector: 'file-loader',
    templateUrl: './file-loader.component.html',
    styleUrl: './file-loader.component.scss',
    providers: [FileLoaderServices],
    standalone: false
})

export class FileLoaderComponent implements OnInit {

  
  @Input()  requiredFileType:string;
  @ViewChild('listcontainer') listContainer: ElementRef;
  fileName = '';
  uploadProgress:number;
  uploadSub: Subscription;
  fileOptions:FileOptions = new FileOptions();  
  files:FileData[] = [];
  totalSize: number;
  maxItensView: number;
  canDelete = true;
  buttonList: ButtonList[] = [];
  destroyed: boolean = false;
  disableUpload: boolean = true;

  constructor(private http: HttpClient, 
              public fileLoader:FileLoaderServices,
              @Inject(MAT_DIALOG_DATA) public data, 
              public dialogRef:MatDialogRef<any>,
              private snackBar:SnackbarService,
              private dialog:DialogService,
              private ts:LanguageServices,
              ) {

                
                if ( data == null || data == undefined || Object.keys(data).length ==0){  
                  this.fileOptions.data = [
                    {
                      name:'CODECOMPANY',
                      type:'I',
                      value:'1'
                    },
                    {
                      name:'CODECONTRACT',
                      type:'I',
                      value:'3'
                    },
                    {
                      name:'CODEMKTP',
                      type:'I',
                      value:'3'
                    },
                    {
                      name:'NAME',
                      type:'S',
                      value:'{@FILENAME}'
                    },
                    {
                      name:'FILETYPE',
                      type:'S',
                      value:'{@FILETYPE}'
                    }
                  ]
                  this.fileOptions.entityName = 'Mktpmedia';
                  this.fileOptions.fileTypeUpload =['.pdf,.xlm'];
                  this.fileOptions.multipleFiles = true;
                  this.fileOptions.condicao = 'INTERNALID = {@INTERNALID}';
                  this.fileOptions.blobField = 'BLOB';
                  this.fileOptions.pk = ['INTERNALID'];
                  this.fileOptions.showCloseButton = true;
                }else{
                  this.fileOptions = this.data;
                }

  }
  ngOnInit(): void {
    
    this.buttonList.push({
      color:"primary",
      description:"Fechar",
      action: (data)=>{
        
        if ( this.files.length > 0 ){
          
          if ( this.files.find(f=>f.progress == 0 || f.progress == null) != null ){
            
            this.dialog.errorDialoag = false;
            this.dialog.infoDialog = false;
            this.dialog.title = "Atenção";
            this.dialog.btnNao = "no";
            this.dialog.btnSim = "yes";
            this.dialog.openNewDialog('fileupload.exitmessage',(dat)=>{
              this.cancelUpload();
              this.closeDialog();
            },()=>{});
            return;
          }else{
            this.closeDialog();
          }
        }else{
          this.closeDialog();
        }
      }
    })  
    
    
  }

  calculateExpirationDate(){
      if ( this.fileOptions.secondsToExpire == null ){
        let date = new Date();
        date.setSeconds(date.getSeconds() + (86400*5));

        return formatDate(date,"yyyy-MM-dd HH:mm:ss.SSS", 'pt-BR','-0300');
      }else{
        let date = new Date();
        date.setSeconds(date.getSeconds() + (this.fileOptions.secondsToExpire));
        return formatDate(date,"yyyy-MM-dd HH:mm:ss.SSS", 'pt-BR','-0300');
      }
  }

  onFileSelected(event) {
      this.maxItensView = this.listContainer.nativeElement.scrollHeight/44;
    
      const filesSelected:File[] = event.target.files;
      let index = 0;

    
      if (filesSelected.length> 0 ) {
        for ( var file of filesSelected ){
          if ( file.size > 10485760 ){
            let s: SnackMessage = {
                      message: this.ts.instant('fileupload.filebig',{filename:file.name}), 
                      tipo: 'error',
                      action: "OK",
                    };
            this.snackBar.addMessage(s);
            continue;
          }

          if ( this.files.findIndex(f=>f.filename == file.name) >-1 ){
            let s: SnackMessage = {
                      message: this.ts.instant('fileupload.exists',{filename:file.name}),
                      tipo: 'error',
                      action: "OK",
                    };
            this.snackBar.addMessage(s);
            continue;
          }

          this.files.push({
              index: this.files.length == 0 ? 1 : this.files[this.files.length - 1].index + 1,
              filename:file.name,
              filetype: file.type,
              size: file.size,
              file: file,
              progress: 0,
              error: null
          })
        }
      }
      this.totalSize = 0;
      this.files.forEach((file)=>{
        this.totalSize += file.size/1024/1024;
      });
      
      this.disableUpload = this.files.length > 0  && this.files.find(f=>f.progress == 0 || f.progress == null) != null ? false : true;      
      
  }

  cancelUpload(){
    this.fileLoader.cancelUpload();
  }

  closeDialog(){
      this.destroyed = true;
      this.dialogRef.close(false);
  }

  removeFile(index:number){
    if ( this.files[index] != null ){
      this.files.splice(index,1);
    }
  }

  ngOnDestroy(){
    if ( this.uploadSub != null ){  
      this.uploadSub.unsubscribe();
    } 
  }

  sendFiles(){
      if ( this.fileOptions.parameters != null ){
        
          this.dialog.openGenericDialog(
            CustomActionParametersComponent,
            this.fileOptions.parameters,
            (data) => {
              //this.executeCustomAction(action, data);
              this.uploadFiles(JSON.parse(data))
            }
          );
      }else{
        this.uploadFiles(null);
      }
  }

  async uploadFiles(parameters:object){

    let objectParam = {};
    if ( parameters != null ){
      Object.keys(parameters).forEach((key)=>{
        objectParam["{@PAR_"+key+"}"] = parameters[key];
      });
    }

    this.canDelete = false;
    for ( var file of this.files.filter(f=>f.progress == 0 || f.progress == null) ){
      
      this.fileName = file.filename;
      let fileType = file.filetype;
      let expirationDate = this.calculateExpirationDate();
    
      if ( this.fileOptions.saveBlob){
        if ( this.fileLoader.progress != null ){
          this.uploadSub = this.fileLoader.progress.subscribe({
            next: (progress) => {
              file.progress = progress;
            } 
          });
        }  
      }
      

      if ( file.index > this.maxItensView ){
        this.listContainer.nativeElement.scrollTo({ top:  this.listContainer.nativeElement.scrollTop + 44, behavior: 'smooth' });
      }
      
      if ( !this.destroyed ){
        await this.fileLoader.saveFileServices(
          this.fileOptions.entityName,
          this.fileOptions.blobField,
          this.fileOptions.data,
          this.fileOptions.condicao,
          this.fileOptions.pk,
          objectParam,
          fileType,
          this.fileName,
          expirationDate,
          this.fileOptions.saveBlob,
          file.file).then(()=>{
            if ( !this.fileOptions.saveBlob ) {
              file.progress = 100;
            }else{
              this.uploadSub.unsubscribe();
              if ( this.fileLoader.progress != null ){
                this.fileLoader.progress.next(0);
              }
            }
            
            
          }).catch((error)=>{
            if ( this.fileOptions.saveBlob ) {
              this.uploadSub.unsubscribe();
              if ( this.fileLoader.progress != null ){
                this.fileLoader.progress.next(0);
              }
            }
            GlobalErrorHandler.stopLoadingEvent();
            file.error = GlobalErrorHandler.getMessage(error);
            
          });
      
      }
        
          
          
          
    }
    this.canDelete = true;
    this.disableUpload = this.files.length > 0  && this.files.find(f=>f.progress == 0 || f.progress == null) != null ? false : true;
    
  }

 
}
